// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1pwfT","footer":"ModalFilter_footer__2NWnp"};